import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';

import {RolleItem} from '../../rolle.model';
import {RollenverwaltungFormdialogComponent} from '../rollenverwaltung-form-dialog/rollenverwaltung-formdialog.component';
import {State} from '../../store/reducer/mitarbeiterverwaltung.reducer';
import {deleteRolleStart} from '../../store/actions/rolle-del.actions';

@Component({
    selector: 'app-rollenverwaltung-table',
    templateUrl: './rollenverwaltung-table.component.html',
    styleUrls: ['./rollenverwaltung-table.component.scss'],
})
export class RollenverwaltungTableComponent implements OnInit {
  public displayedColumns: string[] = [
    'bezeichnung',
    'actions'
  ];

  public dataSource = new MatTableDataSource<RolleItem>();

  constructor( public dialog: MatDialog,
               private store: Store<{ mitarbeiterverwaltung: State }>
  ) {
  }

  /**
   * Sets addresses to datasource
   *
   * @param addresses - The addresses
   */
  @Input()
  public set rollen(rollen: RolleItem[]) {
    this.dataSource.data = rollen;
  }


  public ngOnInit(): void {}

  public editRolle(rolle: RolleItem): void {
    // Öfnnen von Rollen Formular mit mitgegebenen Werten
    const dialogRef = this.dialog.open(RollenverwaltungFormdialogComponent, {
      data: {
        title: 'pages.rollenverwaltung.editRollen.title',
        submitButtonLabel: 'pages.projektverwaltung.addProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.addProjekt.cancelButtonLabel',
        id: rolle.id,
        bezeichnung: rolle.key,
        rechte: rolle.rechte,
      },
    });
    dialogRef.afterClosed().subscribe();
  }

  public deleteRolle(rolle: RolleItem): void {
    this.store.dispatch(deleteRolleStart({item: rolle}));
  }

}
